import { authenticatedRequest } from 'utils/api';
import basicFlow, { genericErrorHandler } from './asyncHandler';
import { all, put, select, takeLatest, takeEvery } from 'redux-saga/effects';
import * as actions from 'reducers/logsIntegracaoPagina.reducer';

const getEstado = (state) => state.logsIntegracaoPagina;

const sanitizeNumeric = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

const sanitizarFiltrosParaApi = (filtros) => {
  const payload = {};
  if (filtros.dataInicioFrom) {
    const d = new Date(filtros.dataInicioFrom);
    if (!Number.isNaN(d.getTime())) payload.dataInicioFrom = d.toISOString();
  }
  if (filtros.dataInicioTo) {
    const d = new Date(filtros.dataInicioTo);
    if (!Number.isNaN(d.getTime())) payload.dataInicioTo = d.toISOString();
  }
  const idOp = sanitizeNumeric(filtros.idOportunidade);
  if (idOp !== null) payload.idOportunidade = idOp;
  const idSim = sanitizeNumeric(filtros.idSimulacao);
  if (idSim !== null) payload.idSimulacao = idSim;
  if (filtros.flagSuccesso !== null && filtros.flagSuccesso !== undefined) {
    payload.flagSuccesso = filtros.flagSuccesso;
  }
  if (Array.isArray(filtros.codigoFluxo) && filtros.codigoFluxo.length > 0) {
    payload.codigoFluxo = filtros.codigoFluxo;
  }
  if (Array.isArray(filtros.tipoEvento) && filtros.tipoEvento.length > 0) {
    payload.tipoEvento = filtros.tipoEvento;
  }
  return payload;
};

const buildSearchBody = (estado) => ({
  filters: sanitizarFiltrosParaApi(estado.filtros),
  sort: estado.sort,
  page: estado.lista.page,
  pageSize: estado.lista.pageSize
});

const buscarApi = (body) =>
  authenticatedRequest({
    url: '/log-auditoria/search',
    method: 'post',
    body
  });

const detalheApi = (id) =>
  authenticatedRequest({
    url: `/log-auditoria/show/${encodeURIComponent(id)}`,
    method: 'get'
  });

const buscar = basicFlow({
  actionGenerator: actions.buscarRequest,
  actionSuccess: actions.buscarSuccess,
  actionFailure: actions.buscarFailure,
  api: buscarApi,
  postFailure: function* ({ error }) {
    yield genericErrorHandler({ error });
  }
});

const detalhe = basicFlow({
  actionGenerator: actions.detalheRequest,
  actionSuccess: actions.detalheSuccess,
  actionFailure: actions.detalheFailure,
  api: detalheApi,
  postFailure: function* ({ error }) {
    yield genericErrorHandler({ error });
  }
});

// Click em "Buscar": monta o body a partir do estado atual e dispatcha
// o request. Centralizado no saga para o componente nao se preocupar.
function* onBuscarClick() {
  const estado = yield select(getEstado);
  yield put(actions.buscarRequest(buildSearchBody(estado)));
}

// Paginacao e sort redisparam a busca (mantendo o ultimo estado de filtros
// usado). Ao contrario do modal, alteracoes de FILTROS NAO redisparam —
// usuario precisa clicar "Buscar" novamente para evitar varreduras inuteis
// enquanto digita.
function* dispararBuscaAposPaginacao() {
  const estado = yield select(getEstado);
  if (estado.lista.buscado) {
    yield put(actions.buscarRequest(buildSearchBody(estado)));
  }
}

function* buscaTriggerWatcher() {
  yield all([
    takeLatest(actions.buscarClick.type, onBuscarClick),
    takeLatest(
      [actions.alterarPaginacao.type, actions.alterarSort.type],
      dispararBuscaAposPaginacao
    )
  ]);
}

function* selecionarLogWatcher() {
  yield takeEvery(actions.selecionarLog.type, function* (action) {
    if (action.payload) {
      yield put(actions.detalheRequest(action.payload));
    }
  });
}

export const sagas = [
  buscar.watcher(),
  detalhe.watcher(),
  buscaTriggerWatcher(),
  selecionarLogWatcher()
];
